import moment from "moment";
import { useState, useEffect, useCallback } from "react";
import { alertSuccess, alertError } from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
// import { RoutePath } from "../../../routes/Routes";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BANNER_TYPE, CONTENT_NEWS_ENUM, CONTENT_TYPE, STATUS_ENUM } from "../website-structure/content/enum/content.enum";
import { ContentApi, contentDataType } from "../../../api/content/content.api";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { TagsApi, tagsList } from "../../../api/tags/tags.api";
import { CategoryApi, categoryList } from "../../../api/category/category.api";

const initialErrorMessage = {
    content_start_date: "",
    content_end_time: "",
    content_name: "",
    content_start_time: "",
    content_end_date: "",
}

export const ManageStateDetail = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();



    const [formState, setFormState] = useState<contentDataType>({
        is_public: false,
        content_start_date: "",
        content_end_time: moment().add(10, 'year').format("HH:mm"),
        content_name: "",
        content_start_time: "",
        content_end_date: moment().add(10, 'year').format("YYYY-MM-DD"),
        banner_type: BANNER_TYPE.TYPE_ONE,
        content_desc: "",
        content_detail: "",
        content_files: [],
        content_categorys: [],
        content_status_name: CONTENT_NEWS_ENUM.NEW,
        content_tags: [],
        content_type: CONTENT_TYPE.CONTENT,
        status: STATUS_ENUM.DRAFT
    })
    const [search_category, set_search_category] = useState<string>("");
    const [content_category, set_content_category] = useState<any[]>([]);
    const [category_data, set_category_data] = useState<any[]>([]);
    const [search_content_tags, set_search_content_tags] = useState<string>("");
    const [content_tags, set_content_tags] = useState<any[]>([]);
    const [content_tag_data, set_content_tag_data] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState<{
        content_start_date: string;
        content_end_time: string;
        content_name: string;
        content_start_time: string;
        content_end_date: string;
    }>(initialErrorMessage)
    const [image_upload, set_image_upload] = useState<File[]>([]);
    const [file_api_url, set_file_api_url] = useState<string>("");
    const [showModal, setShowModal] = useState<string>("")
    const [id_media_file, set_id_media_file] = useState<number | null>(null);
    const [content_no, set_content_no] = useState<string>("");

    const [image_api, set_image_api] = useState<any[]>([]);

    const [count_data, set_count_data] = useState<{ total_like: number, total_view: number, total_shared: number }>({
        total_like: 0,
        total_shared: 0,
        total_view: 0
    })


    const handleChangeFormState = (field: keyof contentDataType, value: any) => {
        clearErrorMessage();
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
    }
    const clearErrorMessage = () => {
        setErrorMessage(initialErrorMessage)
    }

    const handleChangeImageApi = (media_files: any[]) => {
        const media_files_data = media_files?.map((list) => {
            return {
                ...list,
                is_image: true
            }
        })
        set_image_api((prev) => ([...prev, ...media_files_data]))
    }
    const handleDeleteImageApi = (index: number) => {
        set_image_api((prev) => prev.filter((_, i) => i !== index))
    }


    const handleGetDetail = async (id_article: number) => {
        dispatch(setLoading());
        await ContentApi.findOne(id_article).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data || null;
                set_count_data({
                    total_view: +data?.total_view || 0,
                    total_like: +data?.total_like || 0,
                    total_shared: +data?.total_shared || 0,
                })
                const content_category = res.data?.data?.content_categorys?.map((list: any) => {
                    return {
                        ...list,
                        ...list?.category
                    }
                })
                set_content_category(content_category);
                const content_tags = res.data?.data?.content_tags?.map((list: any) => {
                    return {
                        ...list,
                        ...list?.tag
                    }
                }) || [];
                const media_file_data: any[] = data?.content_files || [];
                set_content_tags(content_tags)
                set_content_no(data?.content_no || "")
                if (media_file_data?.length > 0) {
                    const image_data_media_file = media_file_data?.map((list) => {
                        return {
                            ...list,
                            ...list?.media_file,
                            is_image: true
                        }
                    })
                    set_image_api(image_data_media_file);
                }
                setFormState((prev) => ({
                    ...prev,
                    ...data,
                    content_status_name: data?.content_status?.content_status_name,
                    content_start_time: data?.content_start_date ? moment(data?.content_start_date).format("HH:mm") : "",
                    content_end_time: data?.content_end_date ? moment(data?.content_end_date).format("HH:mm") : "",
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetTags = useCallback(async () => {
        let query: tagsList = {
            page: 1,
            limit: 10,
        }
        if (search_content_tags) query.keyword = search_content_tags
        await TagsApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.data?.items || [];
                set_content_tag_data(data_value)
            }
        }).catch((err) => err)
    }, [search_content_tags])
    const handleGetCategory = useCallback(async () => {
        let query: categoryList = {
            page: 1,
            limit: 10,
        }
        if (search_category) query.keyword = search_category
        await CategoryApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.data?.items || [];
                set_category_data(data_value)
            }
        }).catch((err) => err)
    }, [search_category])


    const generateForm = (status: string, is_public?: number): contentDataType => {
        const start_date: string | null = formState.content_start_date
            ? moment(
                `${moment(formState.content_start_date).format("YYYY-MM-DD")}${formState.content_start_time ? ` ${formState.content_start_time}` : ''}`
            ).format(formState.content_start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";

        const end_date: string | null = formState.content_end_date
            ? moment(
                `${moment(formState.content_end_date).format("YYYY-MM-DD")}${formState.content_end_time ? ` ${formState.content_end_time}` : ''}`
            ).format(formState.content_end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";
        return {
            is_public: is_public ? !!is_public : !!formState.is_public,
            // content_end_time: formState.content_end_time,
            content_name: formState.content_name,
            // content_start_time: formState.content_start_time,    
            content_end_date: end_date,
            content_start_date: start_date,
            // status: status,
            banner_type: formState.banner_type,
            content_desc: formState.content_desc,
            content_detail: formState.content_detail,
            content_categorys: content_category?.length > 0 ? content_category?.map((list) => {
                return {
                    id_category: list?.id_category
                }
            }) : [],
            content_status_name: formState.content_status_name,
            content_tags: content_tags?.length > 0 ? content_tags?.map((list) => {
                return {
                    id_tag: list?.id_tag
                }
            }) : [],
            content_type: CONTENT_TYPE.NEWS,
            content_files: image_api?.length > 0 ? image_api?.map((list) => {
                return {
                    id_media_file: list?.id_media_file
                }
            }) : []
        }
    }
    const validate_data = (accept?: boolean): boolean => {
        let is_not_valid: boolean = false;
        if (!formState.content_start_date && accept) {
            setErrorMessage((prev) => ({ ...prev, content_start_date: t("ระบุวันที่เริ่มต้นเผยแพร่") }))
            is_not_valid = true
        }
        if (!formState.content_end_date && accept) {
            setErrorMessage((prev) => ({ ...prev, content_end_date: t("ระบุวันที่สิ้นสุดเผยแพร่") }))
            is_not_valid = true
        }
        if (!formState.content_start_time && accept) {
            setErrorMessage((prev) => ({ ...prev, content_start_time: t("ระบุเวลาที่เริ่มต้นเผยแพร่") }))
            is_not_valid = true
        }
        if (!formState.content_end_time && accept) {
            setErrorMessage((prev) => ({
                ...prev, content_end_time: t("ระบุเวลาที่สิ้นสุดเผยแพร่")
            }))
            is_not_valid = true
        }
        // if (!formState.content_name) {
        //     setErrorMessage((prev) => ({ ...prev, content_name: "ระบุชื่อข่าวประชาสัมพันธ์" }))
        //     is_not_valid = true
        // }
        return is_not_valid
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT") => {
        const body = generateForm(mode === 'DRAFT' ? STATUS_ENUM.DRAFT : STATUS_ENUM.ACTIVE, mode === 'SUBMIT' ? 1 : 0);
        const is_not_valid = validate_data(mode === 'SUBMIT' ? true : false);
        if (is_not_valid) return;
        dispatch(setLoading());
        if (id) {
            await ContentApi.update(+id, body).then((res) => {
                if (res.status < 300) {
                    // if (mode === 'SUBMIT') {
                    //     navigate(-1);
                    // } else {
                    handleGetDetail(+id);
                    // }
                    alertSuccess(t("อัพเดตข่าวประชาสัมพันธ์"), t("อัพเดตข่าวประชาสัมพันธ์ เรียบร้อยแล้ว"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("อัพเดตข่าวประชาสัมพันธ์"), t("อัพเดตข่าวประชาสัมพันธ์ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await ContentApi.create(body).then(async (res) => {
                if (res.status < 300) {
                    alertSuccess(t("เพิ่มข่าวประชาสัมพันธ์"), t("เพิ่มข่าวประชาสัมพันธ์ เรียบร้อยแล้ว"))
                    const id_content = res.data?.data?.id_content;
                    if (id_content) {
                        window.location.replace(routeName.cms_website.content_news_detail.replace(":id", id_content))
                    } else {
                        navigate(routeName.cms_website.content_news);
                    }
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("เพิ่มข่าวประชาสัมพันธ์"), t("เพิ่มข่าวประชาสัมพันธ์ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }


    useEffect(() => {
        handleGetTags();
    }, [handleGetTags])
    useEffect(() => {
        handleGetCategory();
    }, [handleGetCategory])
    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id)
        }
    }, [])


    return {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        image_upload,
        id_media_file,
        set_image_upload,
        set_file_api_url,
        set_id_media_file,
        file_api_url,
        setShowModal,
        handleCloseModal,
        showModal,
        setFormState,
        image_api,
        handleChangeImageApi,
        handleDeleteImageApi,
        content_no,
        content_category,
        set_content_category,
        category_data,
        set_search_category,
        content_tag_data,
        content_tags,
        set_content_tags,
        set_search_content_tags,
        count_data
    }
}